export default __webpack_public_path__ + "static/Good Sleep Makes Better Athletes-a3b853f3fb9f34a64fcb469af07da428.jpg";